import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Input, Spinner } from '@nextui-org/react'
import { GET } from '../../../utils/requests';
import Paginations from '../../../components/Pagination';
import { orders_uri } from '../../../utils/url';
import {TYPES} from '../../../utils/types'
import { Link } from 'react-router-dom';
import PayModal from './Modals/pay';
import DeclineModal from './Modals/decline';
import AllPayModal from './Modals/allpay';
import OrderDetailModal from './Modals/order_detail.js';

const Order = () => {
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({limit:15, all:'', totalPage:'',phoneNo:''});
  const [pay, setPay] = useState({onepay:'', allpay:''});
  const [page, setPage] = useState(1);
  const [checkedValue, setValue] = useState([]);

  useEffect(() => {
    Get();
  }, [page]);

  const Get = async () => {
    setLoad(true);
    const b = await GET(orders_uri+`/all?page=${page}&limit=${pagination.limit}&type=${TYPES.REQUESTED}&phoneNo=${pagination.phoneNo}`);
    setData(b.data.data);
    setPagination({...pagination, all:b.data.all, totalPage:b.data.totalPage});
    // setPagination({...pagination, totalPage:b.data.totalPage});
    setLoad(false);
  };

  const callback =()=> {
    Get();
  }
  
  const changePage = (page) => {
    setPage(page);
  };

  function handleChange(event){
    const {value, checked} = event.target
    const a = checkedValue.includes(value);
    
    if(a){
      return
    }

      if(checked){
        setValue(pre => [...pre, value])
      }else{
        setValue(pre => {
          return [...pre.filter(skill => skill!==value)];
        })
      }
  }

  const isItemChecked = (itemId) => {
    return checkedValue.includes(itemId);
  };

  return (
    <div>
      <div>

      <div className="flex flex-col mr-2 mt-2 font-Roboto">
          <div className="overflow-x-auto shadow-md sm:rounded-md">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden ">
              <div className='bg-white p-4'>
                <div className='flex items-center justify-between mb-2'>
                  <h1 className='text-lg font-bold'>Хүлээгдэж байгаа ачааны мэдээлэл</h1>
                
                </div>
                <div className='flex items-center gap-2'>
                  <input size='' className='border rounded-lg mt-2 focus:border-1 focus:border-blue-600 outline-none w-full p-2 bg-gray-100' placeholder='Хайлт хийх' onChange={(e) => setPagination({...pagination, phoneNo:e.target.value})}/>
                  {
                    load?
                    <Button className='mt-1 bg-gray-200'><Spinner/></Button>
                    :
                    <Button onClick={Get} className='mt-1 bg-gray-200'>Хайх</Button>
                  }
                </div>
              {/* <div className='mt-2'>
                <AllPayModal data={checkedValue} callback={callback}/>
              </div> */}
              </div>
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      {/* <th scope="col" className="p-4 text-sm font-normal">
                      </th> */}
                      <th scope="col" className="p-4 text-sm font-normal">
                        No
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Барааны нэр
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Барааны үнэ
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       
                      </th>
                    </tr>
                  </thead>
                  {
                    load?
                    <div className='flex items-center justify-center  p-4'>
                      <Spinner/>
                      <h1 className=''>Уншиж байна ...</h1>
                    </div>
                    :
                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {
                        data.map((item, index) => {
                          return(
                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                {/* <td className="p-2 w-4 text-center">
                                  <Checkbox value={item.id} checked={isItemChecked(item.id)} onChange={handleChange} />
                                </td> */}
                                <td className="p-2 w-4 text-center">
                                  {index+1}
                                </td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                  <label className=''>{item.name}</label>
                                </td>
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.price}</td>
                                
                                <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                  <OrderDetailModal prod={item} callback={callback}/>
                                </td>
                                {/* <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.user.phone_no}</td>
                                <td className="py-2 px-6 text-sm font-medium whitespace-nowrap dark:text-white text-blue-700">
                                  {item.too}
                                </td>
                                <td className="py-2 px-6 text-sm font-medium whitespace-nowrap dark:text-white text-blue-700">
                                  {item.code}
                                </td>
                                <td className="py-2 px-6 text-sm font-medium whitespace-nowrap dark:text-white text-blue-700 flex items-center gap-2">
                                  <PayModal data={item.id} callback={callback}/>
                                  <DeclineModal data={item.id} callback={callback}/>
                                </td> */}
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
                {
                  data.length === 0 &&
                  <div className='bg-white pt-8 text-center flex items-center justify-center flex-col'>
                    <img className='h-24' src='../../empty.gif'/>
                    <h1 className=''>Хоосон байна...</h1>
                  </div>
                }
               <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
               {/* onChange={changePage} */}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Order


